import { baseApiClient } from './baseService';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface CSVImportUploadResponse {
  workflow_id: string;
  total_rows: number;
  dry_run: boolean;
  message: string;
}

export interface CSVImportWorkflowProgress {
  status: 'PENDING' | 'PARSING' | 'PROCESSING' | 'COMPLETED' | 'FAILED';
  total_rows: number;
  rows_processed: number;
  matched: number;
  skipped: number;
  errored: number;
  contact_points_created: number;
  contact_points_updated: number;
  started_at: string | null;
  completed_at: string | null;
  error_message: string | null;
}

export interface CSVImportRowResult {
  row_index: number;
  provider_name: string;
  status: 'matched' | 'skipped' | 'errored';
  provider_service_id: string | null;
  provider_service_name: string | null;
  contact_points_created: number;
  contact_points_updated: number;
  skip_reason: string | null;
  error: string | null;
}

export interface CSVImportResult {
  total_rows: number;
  matched: number;
  skipped: number;
  errored: number;
  contact_points_created: number;
  contact_points_updated: number;
  dry_run: boolean;
  row_results: CSVImportRowResult[];
}

export interface CSVImportStatusResponse {
  workflow_id: string;
  progress: CSVImportWorkflowProgress;
  result: CSVImportResult | null;
}

// ---------------------------------------------------------------------------
// RTK Query endpoints
// ---------------------------------------------------------------------------

const injectedApi = baseApiClient
  .enhanceEndpoints({
    addTagTypes: ['CSVImportStatus'] as const,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      uploadCSVImport: builder.mutation<CSVImportUploadResponse, FormData>({
        query: (formData) => ({
          url: 'api/provider-directory/v2/csv-import/upload/',
          method: 'POST',
          body: formData,
        }),
      }),

      getCSVImportStatus: builder.query<
        CSVImportStatusResponse,
        { workflowId: string }
      >({
        query: ({ workflowId }) =>
          `api/provider-directory/v2/csv-import/${workflowId}/status/`,
        providesTags: (result, error, { workflowId }) => [
          { type: 'CSVImportStatus', id: workflowId },
        ],
      }),
    }),
    overrideExisting: false,
  });

export { injectedApi as providerDirectoryCSVImportApi };

export const {
  useUploadCSVImportMutation,
  useGetCSVImportStatusQuery,
} = injectedApi;
